import {ObjectDTO} from '../object-dto';
import {UnitedemesureDTO} from "../unitedemesure-dto";

export default class ModeleConditionnementPlatDTO extends ObjectDTO {

  libelle: string;

  code: string;

  mode: string;

  uniteAConditionner: UnitedemesureDTO;

}
